// extracted by mini-css-extract-plugin
export default {"location":"Search_location__zpt2l"};